const firebaseConfig = {
  apiKey: "AIzaSyCqOx-2AQAAetogHtXIaprPPZI_xq9iZE4",
  authDomain: "bike-store-460ff.firebaseapp.com",
  projectId: "bike-store-460ff",
  storageBucket: "bike-store-460ff.appspot.com",
  messagingSenderId: "336987381907",
  appId: "1:336987381907:web:aaca849fc99a6d2cd26d66"
};

export default firebaseConfig;